<template>
  <div class="buyer-delivery-wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/framework/myTrading/myOrder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>买方交收申请详情</el-breadcrumb-item>
    </el-breadcrumb>
    <header-title title="交收信息" />
    <content-table v-if="orderData.length !== 0" :tableData="orderData" labelWidth="130" />
    <div class="table-wrap">
      <el-table :data="deliveryDataList" stripe>
        <el-table-column label="合同号" prop="contractCode" />
        <el-table-column label="分客户号" prop="splitUserAccount" />
        <el-table-column label="订货单价" prop="price" />
        <el-table-column label="交收数量" prop="quantity" />
      </el-table>
    </div>
    <header-title title="提货信息"></header-title>
    <div class="table-wrap" style="margin: 0;">
      <el-table :data="pickUpGoodsDataList" stripe>
        <el-table-column label="提货人" prop="consignee" />
        <el-table-column label="证件类型" prop="papersType" />
        <el-table-column label="证件号码" prop="papersNo" />
        <el-table-column label="电话" prop="phone" />
        <el-table-column label="车号" prop="vehicleNo" />
        <el-table-column label="数量" prop="pickUpQuantity" />
        <el-table-column label="备注" prop="remark" />
      </el-table>
    </div>
    <div class="button-wrap over">
      <el-button class="left-button plain" @click="back">返回</el-button>
      <!--<el-button type="primary">发布</el-button>-->
    </div>
  </div>
</template>

<script>

export default {
  name: 'BuyerDelivery',
  data () {
    return {
      orderData: [], // 订单信息
      deliveryDataList: [], // 交收信息
      pickUpGoodsDataList: [], // 提货信息
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 获取交收单数据
    getData () {
      const url = this.$API.myOrder.myBuyerDeliveryDetail
      const param = {
        id: this.$route.params.id
      }
      this.$http.post(url, param).then(res => {
        const data = res.data.data
        this.deliveryDataList = data.contangoOrderDeliveryDetailList // 交收信息
        this.pickUpGoodsDataList = data.contangoPickUpInformationList // 提货信息
        this.orderData = [ // 用于显示的订单信息
          { key: '会员号', value: data.buyerAccount },
          { key: '会员名称', value: data.buyerName },
          { key: '订单编号', value: data.orderCode },
          { key: '品牌', value: data.brandName },
          { key: '等级', value: data.grade },
          { key: '订单数量', value: data.orderQuantity },
          { key: '升贴水单价', value: data.areaPrice },
          { key: '移仓选择', value: this.$utils.getStatusName(data.moveWarehouseType, this.$key.myOrder.moveWarehouseType) },
          { key: '类型', value: this.$utils.getStatusName(data.deliveryType, this.$key.myOrder.deliveryType) },
          { key: '交货地', value: data.deliveryAddress },
          { key: '备注', value: data.remark }
        ]
      })
    },
    // 返回
    back () {
      this.$router.push({ path: '/framework/myTrading/myOrder' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .buyer-delivery-wrap{
    margin-top: 20px !important;
    .table-wrap{
      margin-top: 32px;
    }
    .button-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        margin-top: 62px;
        margin-bottom: 20px;
      }
    }
  }
</style>
